import React from 'react'
import styles from './serviceDetailSec.module.css'
import { serviceAr } from '../../../assets'
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { LANG_AR, LANG_EN } from '../../helpers/constant';

const ServiceDetailServiceList = ({ servicelist }) => {
    const { t, i18n } = useTranslation();
    return (
        <div className={styles.ServiceDetailServiceList}>
            <div className={styles.ServiceDetailServiceListInner}>
                <h3 className={`${styles.ServiceDetailServiceListTitle} ${i18n.language === LANG_AR ? 'arabText' : ''}`}>{t('detailServices')}</h3>
                <ul className={`${styles.ServiceDetailServiceLists}  ${i18n.language === LANG_AR ? 'arabSerDet' : ''}`}>
                    {servicelist && servicelist.length > 0 && servicelist.map((service, index) => (
                        <li key={index}>
                            <div className={`${styles.ServiceDetailServiceListSec} ${i18n.language === LANG_AR ? "arab" : ''} `}>
                                <span><img className={`${i18n.language === LANG_AR ? 'rotateImage' : ''}`} src={serviceAr} alt="" /></span>
                                <div className={styles.ServiceDetailServiceListSecD}>
                                    {/*  <h3>{service.feature}</h3> */}
                                    <h3>{i18n.language === LANG_EN ? service.feature : service.featureAr}</h3>
                                    {/* <p>test</p> */}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default ServiceDetailServiceList
